import moment from 'moment';
import { environment } from 'environments';
import { getCachedValue, LocalStorageKeys, setCachedValue } from '@shared-utils';

(() => {
  class VisitsController {
    constructor(
      $scope,
      $log,
      $state,
      $location,
      $timeout,
      toastr,
      Notifications,
      Messages,
      Orders,
      Auth,
      $rootScope,
      Services,
      PRESCREENED_ENABLED,
      localStorageService,
      Business,
      Users,
      MedicationsByServiceAPI,
    ) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $state,
        $location,
        $log,
        $timeout,
        toastr,
        Notifications,
        Messages,
        Orders,
        $rootScope,
        Services,
        PRESCREENED_ENABLED,
        localStorageService,
        Business,
        Users,
        MedicationsByServiceAPI,
        //messageState : [],
        currentUser: Auth.profile,
        statuses: [...Orders.STATUSES],
        showSearch: true,
        maxDate: new Date(),
        lessColumns: false,
        savePageLocalStorageKey: 'pagination_save_visits_table',
        medications: [],

        pagination: {
          limit: 100,
          offset: 0,
          sort: 'default',
          order: 'desc',
          total: 0,
          partner: 'all',
          is_slv: 'all',
          timezone: $rootScope.timezones[0].timezone,
        },
        appointmentsPagination: {
          limit: 100,
          offset: 0,
          sort: 'default',
          order: 'asc',
          total: 0,
          schedule_code: 'slv|async_and_phone',
          timezone: $rootScope.timezones[0].timezone,
        },
        historyPagination: {
          limit: 50,
          offset: 0,
          sort: 'default',
          order: 'desc',
          total: 0,
          timezone: $rootScope.timezones[0].timezone,
        },
        cancelledOrdersPagination: {
          limit: 100,
          offset: 0,
          sort: 'default',
          order: 'desc',
          total: 0,
          timezone: $rootScope.timezones[0].timezone,
        },
        mailorderpagination: {
          total: 0,
          limit: 50,
          offset: 0,
          status: 'all',
        },
        lemonaidPharmacyMailorderPagination: {
          total: 0,
          limit: 50,
          offset: 0,
          sort: 'pharmacy_default',
          order: 'desc',
          status: 'all',
        },
        OutboundCallVisitPagination: {
          total: 0,
          limit: 50,
          offset: 0,
          //sort: 'default',
          //order: 'desc',
          status: 'call_needed',
        },
        scanwellShippingPagination: {
          total: 0,
          limit: 50,
          offset: 0,
          // sort: 'default',
          sort: 'paid',
          order: 'asc',
        },
        visitTypes: [
          { type: 'all', description: 'All Visit Types' },
          { type: 'true', description: 'SLV' },
          { type: 'false', description: 'Async' },
        ],
        partnerships: [
          { type: 'all', description: 'All Partners' },
          { type: 'ih', description: 'Lemonaid' },
          { type: 'qd', description: 'Quest Diagnostics' },
        ],
        mailorderstatus: [
          { type: 'all', name: 'All Statuses' },
          { type: 'cancelled', name: 'Cancelled' },
          { type: 'delivered', name: 'Delivered' },
          { type: 'error', name: 'Error' },
          { type: 'incomplete', name: 'Incomplete' },
          { type: 'open', name: 'Open' },
          { type: 'ordered', name: 'Ordered' },
          { type: 'sent', name: 'Sent' },
          { type: 'shipped', name: 'Shipped' },
        ],
        OutboundCallVisitStatuses: [
          { type: 'all', name: 'All Statuses' },
          { type: 'call_needed', name: 'Call Needed' },
          { type: 'left_message', name: 'Left Message' },
          { type: 'call_completed', name: 'Call Completed' },
          { type: 'follow_up', name: 'Follow Up' },
        ],
        ScheduleTypes: [
          { type: 'slv|async_and_phone', name: 'All Visits' },
          { type: 'slv', name: 'SLV' },
          { type: 'async_and_phone', name: 'Async + Call' },

          // As Maksim requested
          // it's ok to show 'cancelled' but please remove 'incomplete', it's payment status
          // { type: 'incomplete', name: 'Incomplete' },

          // As Greg confirmed
          // User should not be able to filter by "open"
          // => User should not see open fill requests

          // { type: 'open', name: 'Open' },
        ],
        lemonaidPharmacyMailorderStatuses: [
          { type: 'all', name: 'All Statuses' },

          { type: 'in-progress', name: 'In Progress' },
          { type: 'on-hold', name: 'On Hold' },

          { type: 'cancelled', name: 'Cancelled' },
          { type: 'delivered', name: 'Delivered' },
          { type: 'error', name: 'Error' },
          { type: 'ordered', name: 'Ordered' },
          { type: 'sent', name: 'Sent' },
          { type: 'shipped', name: 'Shipped' },

          // As Maksim requested
          // it's ok to show 'cancelled' but please remove 'incomplete', it's payment status
          // { type: 'incomplete', name: 'Incomplete' },

          // As Greg confirmed
          // User should not be able to filter by "open"
          // => User should not see open fill requests

          // { type: 'open', name: 'Open' },
        ],

        // USE THIS TO SHOW IN THE MULTISELECT DROPDOWN
        scanwellShippingStatuses: [
          { type: 'all', name: 'All Statuses', selected: true },
          { type: 'in-progress', name: 'In Progress', selected: false },
          { type: 'hold', name: 'On Hold', selected: false },
          { type: 'ordered', name: 'Ordered', selected: false },
          { type: 'shipped', name: 'Shipped', selected: false },
        ],
        // DO NOT USE THIS TO SHOW IN THE MULTISELECT DROPDOWN
        // USE THIS ONLY TO REPLACE THE "STATUS=ALL"
        scanwellShippingStatusesToReplaceAll: [
          { type: 'in-progress' },
          { type: 'hold' },
          { type: 'ordered' },
          { type: 'shipped' },
        ],

        // SCANWELL REVIEWS
        scanwellReviewsPagination: {
          total: 0,
          limit: 3,
          reviewed: 'false',
          locked: 'false',
          lock_records: true,
        },
        // scanwellReviewStatuses: [
        //   { value : "all", description : "Reviewed & Unreviewed"},
        //   { value : "true", description : "Reviewed"},
        //   { value : "false", description : "Unreviewed"}
        // ],
        scanwellLockStatuses: [
          { value: 'all', description: 'Locked & Unlocked' },
          { value: 'true', description: 'Locked' },
          { value: 'false', description: 'Unlocked' },
        ],

        // SCANWELL MATCHING
        scanwellMatchingPagination: {
          total: 0,
          limit: 25,
          status: 'Unmatched',
        },
        scanwellMatchingStatuses: [
          { value: 'all', description: 'All Statuses' },
          { value: 'New', description: 'New' },
          { value: 'Unmatched', description: 'Unmatched' },
          { value: 'Matched', description: 'Matched' },
          { value: 'No Match Found', description: 'No Match Found' },
          { value: 'Duplicate', description: 'Duplicate' },
        ],
      });

      this.BOD_191 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
      this.BOD_634 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);

      // this.$timeout(() => {
      //   this.timezone_selected = this.$rootScope.timezones[0];
      // }, 500);

      // this.getAvailableStates(true);
      this.isInitialLoad = true;
      // Watch for any changes on category_code to fetch medications if there is one selected
      this.$scope.$watch(
        () => this.pagination.category_code,
        (newVal, oldVal) => {
          // Only fetch if its 1 since API does not support multiple
          if (newVal && newVal.length === 1) {
            this.fetchMedicationsByService(newVal[0].category);
          } else {
            this.medications.forEach(medication => (medication.selected = false));
            this.medications = [];
            this.pagination.medication_ids = [];

            // Only clear cache after initial load
            if (!this.isInitialLoad) {
              setCachedValue(LocalStorageKeys.WAITING_ROOM_PAGINATION_MEDICATION_FILTER, []);
            }
          }
        },
        true,
      );
    }

    fetchMedicationsByService(serviceCode) {
      this.MedicationsByServiceAPI.getMedications(serviceCode).subscribe({
        next: data => {
          const cachedMedications = getCachedValue(LocalStorageKeys.WAITING_ROOM_PAGINATION_MEDICATION_FILTER) || [];
          const cachedMedicationCodes = cachedMedications.map(medication => medication.id);
          this.medications = data.map(medication => ({
            name: medication.medication_name,
            id: medication.medication_id,
            selected: cachedMedicationCodes.includes(medication.medication_id),
          }));
        },
        error: () => {
          this.medications = [];
        },
      });
    }

    timezoneChanged() {
      // this.appointmentsPagination.timezone = this.timezone_selected;
      this.appointmentsPagination.offset = 0;
      this.searchAppointments();
    }

    timezoneChangedWaitingRoom() {
      this.pagination.offset = 0;
      this.search();
    }

    timezoneChangedVisitHistory() {
      this.historyPagination.offset = 0;
      this.searchVisitHistory();
    }

    timezoneChangedPatientSupport() {
      this.cancelledOrdersPagination.offset = 0;
      this.searchCancelledOrders();
    }

    getDispensingAndPSTStatuses() {
      this.pstStatuses = [];
      this.dispensingStatuses = [];

      this.Orders.getCancelledOrdersStatuses().then(({ data }) => {
        this.pstStatuses = data.pst;
        this.dispensingStatuses = data.dispensing;
      });
    }

    getAvailableStates(polling = false, tab = 'waiting-room') {
      this.Business.getAvailableStates().then(({ data }) => {
        this.states = [];

        data.forEach(state => {
          this.states.push({ code: state.code, name: state.name, long_name: state.code + ' - ' + state.name });
        });

        this.states_2 = angular.copy(this.states);
        this.states_3 = angular.copy(this.states);
        this.states_4 = angular.copy(this.states);
        this.states_5 = angular.copy(this.states);

        if (tab == 'scanwell-results') {
          this.searchScanwellResults = this.searchScanwellResults.bind(this);
          this.searchScanwellResults();
        } else if (tab == 'scanwell-shipping') {
          this.searchScanwellShipping = this.searchScanwellShipping.bind(this);
          this.searchScanwellShipping();
        } else if (tab == 'appointments') {
          this.initializeCache_appointmentsTab();
          this.loadCachedSearchFilters_appointmentsTab();

          this.searchAppointments = this.searchAppointments.bind(this);
          this.searchAppointments();
        } else {
          this.getCategories(polling, tab);
        }
      });
    }

    getCategories(polling = false, tab = 'waiting-room') {
      this.Orders.getCategories().then(({ data }) => {
        this.localStorageService.set('all_categories', data);

        this.categories = [];

        data.forEach(s => {
          // if(s.children && s.children.length) {
          //   var children_codes = "";
          //   s.children.forEach((c) => {
          //     if (!children_codes) {
          //       children_codes = c.code;
          //     } else {
          //       children_codes = children_codes + "|" + c.code;
          //     }
          //   });
          //   this.categories.push({ name: s.name, category: children_codes });
          // } else {
          //   this.categories.push({ name: s.name, category: s.code });
          // }

          if (s.children && s.children.length) {
            s.children.forEach(c => {
              this.categories.push({ name: c.code + ' - ' + c.display_name, category: c.code });
            });
          } else {
            this.categories.push({ name: s.code + ' - ' + s.display_name, category: s.code });
          }
        });

        this.categories_2 = angular.copy(this.categories);
        this.categories_3 = angular.copy(this.categories);

        if (tab === 'waiting-room') {
          this.initializeCache();
          this.loadCachedSearchFilters();

          this.Services.getCacheAreaCodes(false)
            .then(() => {
              //this.loadLastWindowLocation();
              this.search = this.search.bind(this);
              this.search(polling);
            })
            .catch(() => {
              //this.loadLastWindowLocation();
              this.search = this.search.bind(this);
              this.search(polling);
            });
        } else if (tab === 'cancelled-orders') {
          this.getDispensingAndPSTStatuses();

          this.initializeCache_cancelledOrdersTab();
          this.loadCachedSearchFilters_cancelledOrdersTab();

          this.searchCancelledOrders = this.searchCancelledOrders.bind(this);
          this.searchCancelledOrders();
        } else if (tab === 'visit-history') {
          this.initializeCache();
          this.loadCachedSearchFilters();

          this.Users.getStaffUsers('?active=true')
            .then(({ data }) => {
              this.users = [];

              data.forEach(user => {
                this.users.push({ staff_user_id: user.id, name: user.firstname + ' ' + user.lastname });
              });

              this.searchVisitHistory = this.searchVisitHistory.bind(this);
              this.searchVisitHistory();
            })
            .catch(err => {
              this.users = [];

              this.searchVisitHistory = this.searchVisitHistory.bind(this);
              this.searchVisitHistory();
            });
        }
      });
    }

    initializeCache() {
      // Here we initialize the cached filter values
      if (this.localStorageService.get('filter_show_d80only') === undefined)
        this.localStorageService.set('filter_show_d80only', false);
      if (this.localStorageService.get('save_visit_search') === undefined)
        this.localStorageService.set('save_visit_search', false);
      if (this.localStorageService.get('filter_include_flagged') === undefined)
        this.localStorageService.set('filter_include_flagged', false);
      if (this.localStorageService.get('filter_search') === undefined)
        this.localStorageService.set('filter_search', null);
      if (this.localStorageService.get('filter_admin_status') === undefined)
        this.localStorageService.set('filter_admin_status', []);
      if (this.localStorageService.get('filter_start_time') === undefined)
        this.localStorageService.set('filter_start_time', null);
      if (this.localStorageService.get('filter_end_time') === undefined)
        this.localStorageService.set('filter_end_time', null);
      if (this.localStorageService.get('filter_is_slv') === undefined)
        this.localStorageService.set('filter_is_slv', 'all');
      if (this.localStorageService.get('filter_partner') === undefined)
        this.localStorageService.set('filter_partner', 'all');
      if (this.localStorageService.get('filter_state') === undefined) this.localStorageService.set('filter_state', []);
      if (this.localStorageService.get('filter_category') === undefined)
        this.localStorageService.set('filter_category', []);
      if (this.localStorageService.get(LocalStorageKeys.WAITING_ROOM_PAGINATION_MEDICATION_FILTER) === undefined)
        setCachedValue(LocalStorageKeys.WAITING_ROOM_PAGINATION_MEDICATION_FILTER, []);
    }

    initializeCache_appointmentsTab() {
      // Here we initialize the cached filter values
      if (this.localStorageService.get('appoint_tab_save_visit_search') === undefined)
        this.localStorageService.set('appoint_tab_save_visit_search', false);
      if (this.localStorageService.get('appoint_tab_filter_state') === undefined)
        this.localStorageService.set('appoint_tab_filter_state', []);
      if (this.localStorageService.get('appoint_tab_timezone') === undefined)
        this.localStorageService.set('appoint_tab_timezone', this.$rootScope.timezones[0].timezone);
      if (this.localStorageService.get('appoint_tab_schedule_code') === undefined)
        this.localStorageService.set('appoint_tab_schedule_code', 'slv|async_and_phone');
    }

    initializeCache_cancelledOrdersTab() {
      // Here we initialize the cached filter values
      if (this.localStorageService.get('cancelled_orders_tab_save_visit_search') === undefined)
        this.localStorageService.set('cancelled_orders_tab_save_visit_search', false);
      if (this.localStorageService.get('cancelled_orders_filter_search') === undefined)
        this.localStorageService.set('cancelled_orders_filter_search', null);

      // We set default date filters values with today
      if (this.localStorageService.get('cancelled_orders_filter_start_time') === undefined)
        this.localStorageService.set('cancelled_orders_filter_start_time', moment().startOf('day').toISOString());
      if (this.localStorageService.get('cancelled_orders_filter_end_time') === undefined)
        this.localStorageService.set('cancelled_orders_filter_end_time', moment().startOf('day').toISOString());

      if (this.localStorageService.get('cancelled_orders_filter_dispensing_status') === undefined)
        this.localStorageService.set('cancelled_orders_filter_dispensing_status', []);
      if (this.localStorageService.get('cancelled_orders_filter_store_status') === undefined)
        this.localStorageService.set('cancelled_orders_filter_store_status', []);
      if (this.localStorageService.get('cancelled_orders_filter_category') === undefined)
        this.localStorageService.set('cancelled_orders_filter_category', []);
    }

    loadCachedSearchFilters() {
      // Here we load the "saved" filter values
      this.savedSearch = this.localStorageService.get('save_visit_search');

      if (this.savedSearch) {
        this.includeFlagged = this.localStorageService.get('filter_include_flagged');
        this.showD80only = this.localStorageService.get('filter_show_d80only');
        if (this.showD80only) this.pagination.is_mailorder = true;
        this.pagination.search = this.localStorageService.get('filter_search');

        // TO SOLVE DATE OBJECT CACHE PROBLEM
        let start_time = this.localStorageService.get('filter_start_time');
        let end_time = this.localStorageService.get('filter_end_time');

        if (!start_time) {
          this.start_time_date_object = null;
          this.clearInput('datepicker-tab1-startdate');
        } else if (moment(start_time, 'YYYY-MM-DD').isValid()) {
          this.start_time_date_object = new Date(start_time)
            ? new Date(new Date(start_time).setHours(0, 0, 0, 0))
            : null;
        } else {
          this.start_time_date_object = null;
          this.clearInput('datepicker-tab1-startdate');
        }

        if (!end_time) {
          this.end_time_date_object = null;
          this.clearInput('datepicker-tab1-enddate');
        } else if (moment(end_time, 'YYYY-MM-DD').isValid()) {
          this.end_time_date_object = new Date(end_time) ? new Date(new Date(end_time).setHours(0, 0, 0, 0)) : null;
        } else {
          this.end_time_date_object = null;
          this.clearInput('datepicker-tab1-enddate');
        }

        this.pagination.is_slv = this.localStorageService.get('filter_is_slv');
        this.pagination.partner = this.localStorageService.get('filter_partner');

        this.pagination.admin_status = this.localStorageService.get('filter_admin_status');
        this.pagination.state = this.localStorageService.get('filter_state');
        this.pagination.category_code = this.localStorageService.get('filter_category');
        this.pagination.medication_ids = getCachedValue(LocalStorageKeys.WAITING_ROOM_PAGINATION_MEDICATION_FILTER);

        this.states.forEach(s => {
          s.selected = false;
        });

        this.categories.forEach(s => {
          s.selected = false;
        });

        this.statuses.forEach(s => {
          s.selected = false;
        });

        if (_.isArray(this.pagination.state) && this.pagination.state.length) {
          this.pagination.state.forEach(elem_state => {
            this.states.forEach(s => {
              if (elem_state.code === s.code) {
                s.selected = true;
              }
            });
          });
        }

        if (_.isArray(this.pagination.category_code) && this.pagination.category_code.length) {
          this.pagination.category_code.forEach(elem_state => {
            this.categories.forEach(s => {
              if (elem_state.category === s.category) {
                s.selected = true;
              }
            });
          });
        }

        if (_.isArray(this.pagination.admin_status) && this.pagination.admin_status.length) {
          this.pagination.admin_status.forEach(elem_status => {
            this.statuses.forEach(s => {
              if (elem_status.status === s.status) {
                s.selected = true;
              }
            });
          });
        }
      } else {
        this.resetFilters();
      }
      this.isInitialLoad = false;
    }

    loadCachedSearchFilters_appointmentsTab() {
      // Here we load the "saved" filter values
      this.appointmentsTab_savedSearch = this.localStorageService.get('appoint_tab_save_visit_search');

      if (this.appointmentsTab_savedSearch) {
        this.appointmentsPagination.state = this.localStorageService.get('appoint_tab_filter_state');

        this.states_2.forEach(s => {
          s.selected = false;
        });

        if (_.isArray(this.appointmentsPagination.state) && this.appointmentsPagination.state.length) {
          this.appointmentsPagination.state.forEach(elem_state => {
            this.states_2.forEach(s => {
              if (elem_state.code === s.code) {
                s.selected = true;
              }
            });
          });
        }

        this.appointmentsPagination.timezone = this.localStorageService.get('appoint_tab_timezone');
        this.appointmentsPagination.schedule_code = this.localStorageService.get('appoint_tab_schedule_code');
      } else {
        this.resetFilters_appointmentsTab();
      }
    }

    loadCachedSearchFilters_cancelledOrdersTab() {
      // Here we load the "saved" filter values
      this.cancelledOrdersTab_savedSearch = this.localStorageService.get('cancelled_orders_tab_save_visit_search');

      if (this.cancelledOrdersTab_savedSearch) {
        this.cancelledOrdersPagination.search = this.localStorageService.get('cancelled_orders_filter_search');

        // TO SOLVE DATE OBJECT CACHE PROBLEM
        let start_time = this.localStorageService.get('cancelled_orders_filter_start_time');
        let end_time = this.localStorageService.get('cancelled_orders_filter_end_time');

        if (!start_time) {
          this.cancelled_orders_start_time_date_object = null;
          this.clearInput('datepicker-tab10-startdate');
        } else if (moment(start_time, 'YYYY-MM-DD').isValid()) {
          this.cancelled_orders_start_time_date_object = new Date(start_time)
            ? new Date(new Date(start_time).setHours(0, 0, 0, 0))
            : null;
        } else {
          this.cancelled_orders_start_time_date_object = null;
          this.clearInput('datepicker-tab10-startdate');
        }

        if (!end_time) {
          this.cancelled_orders_end_time_date_object = null;
          this.clearInput('datepicker-tab10-enddate');
        } else if (moment(end_time, 'YYYY-MM-DD').isValid()) {
          this.cancelled_orders_end_time_date_object = new Date(end_time)
            ? new Date(new Date(end_time).setHours(0, 0, 0, 0))
            : null;
        } else {
          this.cancelled_orders_end_time_date_object = null;
          this.clearInput('datepicker-tab10-enddate');
        }

        this.cancelledOrdersPagination.service_code = this.localStorageService.get('cancelled_orders_filter_category');
        this.cancelledOrdersPagination.dispensing_status = this.localStorageService.get(
          'cancelled_orders_filter_dispensing_status',
        );
        this.cancelledOrdersPagination.pst_status = this.localStorageService.get(
          'cancelled_orders_filter_store_status',
        );

        this.categories_3.forEach(s => {
          s.selected = false;
        });

        this.dispensingStatuses.forEach(s => {
          s.selected = false;
        });

        this.pstStatuses.forEach(s => {
          s.selected = false;
        });

        if (
          _.isArray(this.cancelledOrdersPagination.service_code) &&
          this.cancelledOrdersPagination.service_code.length
        ) {
          this.cancelledOrdersPagination.service_code.forEach(elem_state => {
            this.categories_3.forEach(s => {
              if (elem_state.category === s.category) {
                s.selected = true;
              }
            });
          });
        }

        if (
          _.isArray(this.cancelledOrdersPagination.dispensing_status) &&
          this.cancelledOrdersPagination.dispensing_status.length
        ) {
          this.cancelledOrdersPagination.dispensing_status.forEach(elem_status => {
            this.dispensingStatuses.forEach(s => {
              if (elem_status.dispensing_status === s.dispensing_status) {
                s.selected = true;
              }
            });
          });
        }

        if (_.isArray(this.cancelledOrdersPagination.pst_status) && this.cancelledOrdersPagination.pst_status.length) {
          this.cancelledOrdersPagination.state.forEach(elem_state => {
            this.pstStatuses.forEach(s => {
              if (elem_state.pst_status === s.pst_status) {
                s.selected = true;
              }
            });
          });
        }
      } else {
        this.resetFilters_cancelledOrdersTab();
      }
    }

    cacheSaveFilter() {
      if (this.savedSearch) {
        this.localStorageService.set('save_visit_search', true);
      } else {
        this.localStorageService.set('save_visit_search', false);
      }

      this.cacheSearchFilters();
    }

    cacheSaveFilter_appointmentsTab() {
      if (this.appointmentsTab_savedSearch) {
        this.localStorageService.set('appoint_tab_save_visit_search', true);
      } else {
        this.localStorageService.set('appoint_tab_save_visit_search', false);
      }

      this.cacheSearchFilters_appointmentsTab();
    }

    cacheSaveFilter_cancelledOrdersTab() {
      if (this.cancelledOrdersTab_savedSearch) {
        this.localStorageService.set('cancelled_orders_tab_save_visit_search', true);
      } else {
        this.localStorageService.set('cancelled_orders_tab_save_visit_search', false);
      }

      this.cacheSearchFilters_cancelledOrdersTab();
    }

    cacheSearchFilters() {
      // Here we save the filter
      if (this.savedSearch) {
        this.localStorageService.set('filter_show_d80only', this.showD80only);
        this.localStorageService.set('filter_include_flagged', this.includeFlagged);
        this.localStorageService.set('filter_search', this.pagination.search);
        this.localStorageService.set('filter_admin_status', this.pagination.admin_status);
        setCachedValue(LocalStorageKeys.WAITING_ROOM_PAGINATION_MEDICATION_FILTER, this.pagination.medication_ids);

        // TO SOLVE DATE OBJECT CACHE PROBLEM
        this.localStorageService.set(
          'filter_start_time',
          this.start_time_date_object && _.isDate(this.start_time_date_object)
            ? moment(this.start_time_date_object).startOf('day').toISOString()
            : null,
        );
        this.localStorageService.set(
          'filter_end_time',
          this.end_time_date_object && _.isDate(this.end_time_date_object)
            ? moment(this.end_time_date_object).startOf('day').toISOString()
            : null,
        );

        this.localStorageService.set('filter_is_slv', this.pagination.is_slv);
        this.localStorageService.set('filter_partner', this.pagination.partner);
        this.localStorageService.set('filter_state', this.pagination.state);
        this.localStorageService.set('filter_category', this.pagination.category_code);
      } else {
        this.localStorageService.set('filter_show_d80only', false);
        this.localStorageService.set('filter_include_flagged', false);
        this.localStorageService.set('filter_search', null);
        this.localStorageService.set('filter_admin_status', []);
        this.localStorageService.set('filter_start_time', null);
        this.localStorageService.set('filter_end_time', null);
        this.localStorageService.set('filter_is_slv', 'all');
        this.localStorageService.set('filter_partner', 'all');
        this.localStorageService.set('filter_state', []);
        this.localStorageService.set('filter_category', []);
        setCachedValue(LocalStorageKeys.WAITING_ROOM_PAGINATION_MEDICATION_FILTER, []);
      }
    }

    cacheSearchFilters_appointmentsTab() {
      // Here we save the filter values
      if (this.appointmentsTab_savedSearch) {
        this.localStorageService.set('appoint_tab_filter_state', this.appointmentsPagination.state);
        this.localStorageService.set('appoint_tab_timezone', this.appointmentsPagination.timezone);
        this.localStorageService.set('appoint_tab_schedule_code', this.appointmentsPagination.schedule_code);
      } else {
        this.localStorageService.set('appoint_tab_filter_state', []);
        this.localStorageService.set('appoint_tab_timezone', this.$rootScope.timezones[0].timezone);
        this.localStorageService.set('appoint_tab_timezone', 'slv|async_and_phone');
      }
    }

    cacheSearchFilters_cancelledOrdersTab() {
      // Here we save the filter values
      if (this.cancelledOrdersTab_savedSearch) {
        this.localStorageService.set('cancelled_orders_filter_search', this.cancelledOrdersPagination.search);

        // TO SOLVE DATE OBJECT CACHE PROBLEM
        this.localStorageService.set(
          'cancelled_orders_filter_start_time',
          this.cancelled_orders_start_time_date_object && _.isDate(this.cancelled_orders_start_time_date_object)
            ? moment(this.cancelled_orders_start_time_date_object).startOf('day').toISOString()
            : null,
        );
        this.localStorageService.set(
          'cancelled_orders_filter_end_time',
          this.cancelled_orders_end_time_date_object && _.isDate(this.cancelled_orders_end_time_date_object)
            ? moment(this.cancelled_orders_end_time_date_object).startOf('day').toISOString()
            : null,
        );

        this.localStorageService.set(
          'cancelled_orders_filter_dispensing_status',
          this.cancelledOrdersPagination.disepnsing_status,
        );
        this.localStorageService.set('cancelled_orders_filter_store_status', this.cancelledOrdersPagination.partner);
        this.localStorageService.set('cancelled_orders_filter_category', this.cancelledOrdersPagination.service_code);
      } else {
        this.localStorageService.set('cancelled_orders_filter_search', null);

        this.localStorageService.set('cancelled_orders_filter_start_time', moment().startOf('day').toISOString());
        this.localStorageService.set('cancelled_orders_filter_end_time', moment().startOf('day').toISOString());

        this.localStorageService.set('cancelled_orders_filter_store_status', []);
        this.localStorageService.set('cancelled_orders_filter_dispensing_status', []);
        this.localStorageService.set('cancelled_orders_filter_category', []);
      }
    }

    clearInput(elementId) {
      this.$timeout(() => {
        let x = document.getElementById(elementId);
        x.querySelector('input').value = '';
      });
    }

    resetFilters() {
      // Here we clear the filter values
      this.includeFlagged = false;

      this.showD80only = false;
      delete this.pagination.is_mailorder;

      this.pagination.search = null;

      this.states.forEach(s => {
        s.selected = false;
      });

      this.categories.forEach(s => {
        s.selected = false;
      });

      this.statuses.forEach(s => {
        s.selected = false;
      });

      this.pagination.admin_status = [];
      this.pagination.state = [];
      this.pagination.category_code = [];

      // TO SOLVE DATE OBJECT CACHE PROBLEM
      this.start_time_date_object = null;
      this.clearInput('datepicker-tab1-startdate');
      this.end_time_date_object = null;
      this.clearInput('datepicker-tab1-enddate');

      this.pagination.is_slv = 'all';
      this.pagination.partner = 'all';
    }

    resetFilters_appointmentsTab() {
      // Here we clear the filter values
      this.states_2.forEach(s => {
        s.selected = false;
      });

      this.appointmentsPagination.state = [];

      this.appointmentsPagination.timezone = this.$rootScope.timezones[0].timezone;
      this.appointmentsPagination.schedule_code = 'slv|async_and_phone';
    }

    resetFilters_cancelledOrdersTab() {
      // Here we clear the filter values
      this.categories_3.forEach(s => {
        s.selected = false;
      });

      this.pstStatuses.forEach(s => {
        s.selected = false;
      });

      this.dispensingStatuses.forEach(s => {
        s.selected = false;
      });

      // TO SOLVE DATE OBJECT CACHE PROBLEM
      this.cancelled_orders_start_time_date_object = new Date(new Date().setHours(0, 0, 0, 0));
      this.cancelled_orders_end_time_date_object = new Date(new Date().setHours(0, 0, 0, 0));

      this.cancelledOrdersPagination.search = null;
    }

    onChangeShowD80only() {
      if (this.showD80only) {
        this.pagination.is_mailorder = true;
      } else {
        delete this.pagination.is_mailorder;
      }
    }

    search(polling = false) {
      this.cacheSearchFilters();

      var this2 = this;
      this.loading = true;

      this.Orders.search(
        this.pagination,
        this.includeFlagged,
        polling,
        this2.start_time_date_object,
        this2.end_time_date_object,
      )
        .then(({ data }) => {
          Object.assign(this2.pagination, data.pagination);

          var visits = data.data;

          visits.forEach(visit => {
            visit.has_rejected = false;
            for (var service in visit.user.visit_counts) {
              if (visit.user.visit_counts[service].rejected) {
                visit.has_rejected = true;
                break;
              }
            }
          });

          this2.updateWindowLocation(this2.pagination);
          this2.visits = visits;
        })
        .catch(() => this.toastr.error(this.Notifications.generic.failure))
        .finally(() => {
          this.loading = false;
        });
    }

    searchAppointments() {
      this.cacheSearchFilters_appointmentsTab();

      var this2 = this;
      this.loading = true;

      this.Orders.searchAppointments(this2.appointmentsPagination)
        .then(({ data }) => {
          Object.assign(this2.appointmentsPagination, data.pagination);

          // SPRINT 130
          // WE DECIDE TO REMOVE THIS
          // WE WILL RETHINK IN SPRINT 131

          // data.data.sort(function (a, b) {
          //   if(a.call_booking.start_time == b.call_booking.start_time) {
          //     return (a.id < b.id) ? -1 : (a.id > b.id) ? 1 : 0;
          //   } else {
          //     return (a.call_booking.start_time < b.call_booking.start_time) ? -1 : 1;
          //   }
          // });

          // var previous_start_time = null;
          // var charCode = 65;

          data.data.forEach(appointment => {
            // if (!previous_start_time || (previous_start_time != appointment.call_booking.start_time)) {
            //   charCode = 65;
            // } else {
            //   charCode++;
            // }

            appointment.letter = String.fromCharCode(64 + appointment.call_booking.group);
            //previous_start_time = appointment.call_booking.start_time;
          });

          // console.log("appointments: ",data.data);

          this2.appointmentsList = data.data;
        })
        .catch(() => this.toastr.error(this.Notifications.generic.failure))
        .finally(() => {
          this.loading = false;
        });
    }

    searchVisitHistory() {
      var this2 = this;
      this.loading = true;

      this.Orders.searchVisitHistory(this2.historyPagination)
        .then(({ data }) => {
          Object.assign(this2.historyPagination, data.pagination);

          this2.historyVisits = data.data;
        })
        .catch(() => this.toastr.error(this.Notifications.generic.failure))
        .finally(() => {
          this.loading = false;
        });
    }

    searchCancelledOrders() {
      this.cacheSearchFilters_cancelledOrdersTab();

      var this2 = this;
      this.loading = true;

      this.Orders.searchCancelledOrders(
        this2.cancelledOrdersPagination,
        this2.cancelled_orders_start_time_date_object,
        this2.cancelled_orders_end_time_date_object,
      )
        .then(({ data }) => {
          Object.assign(this2.cancelledOrdersPagination, data.pagination);

          this2.cancelledOrders = data.data;
        })
        .catch(() => this.toastr.error(this.Notifications.generic.failure))
        .finally(() => {
          this.loading = false;
        });
    }

    searchMailOrder() {
      var this2 = this;
      this.loading = true;

      this.Orders.searchMailOrder(this2.mailorderpagination)
        .then(({ data }) => {
          Object.assign(this2.mailorderpagination, data.pagination);

          this2.mailordervisits = data.data;
        })
        .catch(() => this.toastr.error(this.Notifications.generic.failure))
        .finally(() => {
          this.loading = false;
        });
    }

    searchLemonaidPharmacyMailorder() {
      var this2 = this;
      this.loading = true;

      this.Orders.searchLemonaidPharmacyMailorder(this2.lemonaidPharmacyMailorderPagination)
        .then(({ data }) => {
          Object.assign(this2.lemonaidPharmacyMailorderPagination, data.pagination);

          this2.lemonaidPharmacyMailorderVisits = data.data;
        })
        .catch(() => this.toastr.error(this.Notifications.generic.failure))
        .finally(() => {
          this.loading = false;
        });
    }

    searchOutboundCallVisit() {
      this.visitStatuses = {
        all: 'All Statuses',
        call_needed: 'Call Needed',
        left_message: 'Left Message',
        call_completed: 'Call Completed',
        follow_up: 'Follow Up',
      };

      var this2 = this;
      this.loading = true;

      this.Orders.searchOutboundCallVisit(this2.OutboundCallVisitPagination)
        .then(({ data }) => {
          Object.assign(this2.OutboundCallVisitPagination, data.pagination);

          this2.OutboundCallVisits = data.data;

          this2.OutboundCallVisits.map(visit => {
            let status = visit.followup.status;
            visit.followup.formattedStatus = this2.visitStatuses[status] ? this2.visitStatuses[status] : '';
            return visit;
          });
        })
        .catch(() => this.toastr.error(this.Notifications.generic.failure))
        .finally(() => {
          this.loading = false;
        });
    }

    searchScanwellMatching() {
      var this2 = this;
      this.loading = true;

      this.Orders.searchScanwellMatching(this2.scanwellMatchingPagination)
        .then(({ data }) => {
          // THERE IS NO SUPPORT FOR PAGINATION ON THIS ENDPOINT
          // Object.assign(this2.scanwellMatchingPagination, data.pagination);

          this2.scanwellResultsMatching = data.data;
        })
        .catch(err => {
          // THIS IS THE WAY TO DISPLAY ERRORS FOR GO ENDPOINTS
          if (err && err.data && err.data.error_message) {
            this.toastr.error(err.data.error_message);
          } else {
            this.toastr.error(this.Notifications.generic.failure);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

    scanwellResultsLoadMore() {
      this.scanwellReviewsPagination.offset += this.scanwellReviewsPagination.limit;
      this.searchScanwellResults();
    }

    searchScanwellResults() {
      var this2 = this;
      this.loading = true;

      this.Orders.searchScanwellResults(this2.scanwellReviewsPagination)
        .then(({ data }) => {
          Object.assign(this2.scanwellReviewsPagination, data.pagination);

          this2.scanwellResultsReview = data.data;
        })
        .catch(err => {
          // THIS IS THE WAY TO DISPLAY ERRORS FOR GO ENDPOINTS
          if (err && err.data && err.data.error_message) {
            this.toastr.error(err.data.error_message);
          } else {
            this.toastr.error(this.Notifications.generic.failure);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

    searchScanwellShipping() {
      var found = this.scanwellStatusesSelected.find(x => x.type === 'all');

      if (found) {
        this.scanwellShippingPagination.status = this.scanwellShippingStatusesToReplaceAll;
      } else {
        this.scanwellShippingPagination.status = this.scanwellStatusesSelected;
      }

      var this2 = this;
      this.loading = true;

      this.Orders.searchScanwellShipping(this2.scanwellShippingPagination)
        .then(({ data }) => {
          Object.assign(this2.scanwellShippingPagination, data.pagination);

          this2.scanwellCovidMailorderVisits = data.data;
        })
        .catch(err => {
          // THIS IS THE WAY TO DISPLAY ERRORS FOR GO ENDPOINTS
          if (err && err.data && err.data.error_message) {
            this.toastr.error(err.data.error_message);
          } else {
            this.toastr.error(this.Notifications.generic.failure);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

    updateWindowLocation(pagination) {
      this.$location.search({
        limit: pagination.limit,
        offset: pagination.offset,
        sort: pagination.sort,
        order: pagination.order,
        search: pagination.search,
        is_slv: pagination.is_slv === 'all' ? undefined : pagination.is_slv,
        partner: pagination.partner === 'all' ? undefined : pagination.partner,

        // TO SOLVE DATE OBJECT CACHE PROBLEM
        // start_time: _.isDate(pagination.start_time) ? pagination.start_time.getTime() : undefined,
        // end_time: _.isDate(pagination.end_time) ? pagination.end_time.getTime() : undefined,
        start_time: pagination.start_time ? pagination.start_time : undefined,
        end_time: pagination.end_time ? pagination.end_time : undefined,

        admin_status:
          _.isArray(pagination.admin_status) && pagination.admin_status.length
            ? pagination.admin_status.map(s => s.status).join('|')
            : undefined,
        category_code:
          _.isArray(pagination.category_code) && pagination.category_code.length
            ? pagination.category_code.map(s => s.category).join('|')
            : undefined,
        state:
          _.isArray(pagination.state) && pagination.state.length
            ? pagination.state.map(s => s.code).join('|')
            : undefined,
      });
    }
  }

  VisitsController.$inject = [
    '$scope',
    '$log',
    '$state',
    '$location',
    '$timeout',
    'toastr',
    'Notifications',
    'Messages',
    'Orders',
    'Auth',
    '$rootScope',
    'Services',
    'PRESCREENED_ENABLED',
    'localStorageService',
    'Business',
    'Users',
    'MedicationsByServiceAPI',
  ];
  angular.module('pims').controller('VisitsController', VisitsController);
})();
